var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("z-table", {
        directives: [
          {
            name: "loading",
            rawName: "v-loading",
            value: _vm.loading,
            expression: "loading",
          },
        ],
        attrs: {
          columns: _vm.columns,
          data: _vm.data,
          pagination: false,
          height: "600px",
        },
        scopedSlots: _vm._u([
          {
            key: "loginName",
            fn: function (ref) {
              var row = ref.row
              return [_c("span", [_vm._v(_vm._s(row.loginName || "--"))])]
            },
          },
          {
            key: "accountNumber",
            fn: function (ref) {
              var row = ref.row
              return [_c("span", [_vm._v(_vm._s(row.accountNumber || "--"))])]
            },
          },
          {
            key: "merchantName",
            fn: function (ref) {
              var row = ref.row
              return [_c("span", [_vm._v(_vm._s(row.merchantName || "--"))])]
            },
          },
          {
            key: "handle",
            fn: function (ref) {
              var row = ref.row
              return [
                _c(
                  "el-button",
                  {
                    staticStyle: { color: "#e62c11" },
                    attrs: { type: "text" },
                    on: {
                      click: function ($event) {
                        return _vm.remove(row)
                      },
                    },
                  },
                  [_vm._v(_vm._s(_vm.$t("system::rbac::移除")))]
                ),
              ]
            },
          },
        ]),
      }),
      _c("AddStaff", {
        attrs: { roleId: _vm.role.roleId },
        on: { refresh: _vm.refresh },
        model: {
          value: _vm.isShowAdd,
          callback: function ($$v) {
            _vm.isShowAdd = $$v
          },
          expression: "isShowAdd",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }